import Vue from 'vue'
import i18n from '@/i18n'

const vue = new Vue({ i18n })
export default [
    {
        path: '/',
        view: 'Home',
        meta:{
            title: vue.$t("Router.Common.home"),
        }        
    },        
    /*************************************************
    * Autenticação
    *************************************************/      
    {
        path: '/acesso-negado',
        view: 'authentication/UnathorizedAccess', 
        meta:{
            title: vue.$t("Router.Common.access-denied"),
            requiresAuth: false
        }
    },
    {
        path: '/callback',
        view: 'authentication/Callback', 
        meta:{
            requiresAuth: false
        }
    },
    {
        path: '/silent-renew',
        view: 'authentication/SilentRenew', 
        meta:{
            requiresAuth: false
        }
    },
    {
        path: '/logout',
        view: 'authentication/Logout', 
        meta:{
            requiresAuth: true
        }
    },    
    /*************************************************
    * Página não encontrada
    *************************************************/      
    {
        path: '/pagina-nao-encontrada',
        view: 'PageNotFound', 
        meta:{
            title: vue.$t("Router.Common.page-not-found"),
            requiresAuth: false
        }
    },       
]
